<template>
    <el-row class="real-box" style="background:#010D27;">
        <el-col :span="7" class="box-h">
            <div class="grid-content stateData" style="height:62%;overflow: auto;">
                <div class="grid-tab">
                    <div class="grid-tab-head">
                        <div>
                            <span class="title color3" style="font-weight: bold;">项目进度统计</span>
                            <span class="box-green"></span>
                        </div>
                        <!-- <router-link to="/laborWarn" class="more">更多...</router-link> -->
                    </div>
                    <div class="hr"></div>
                    <div class="progress-item" v-for="item in progressList" :key="item.id">
                        <p style="width:100%;display:flex;padding: 10px;">
                            <span class="nowrap" :title="item.name" style="display: inline-block;margin:0 10px;text-align: left;flex:1;color:#4D7BF4;">{{item.name}}</span>
                            <span style="display: inline-block;margin:0 10px;width: 100px;text-align: left;">工期{{item.allDay}}天</span>
                            <span style="display: inline-block;margin:0 10px;width: 80px;text-align: left;">进度{{item.progress}}%</span>
                            <span style="display: inline-block;margin:0 10px;width: 120px;text-align: left;">剩余工期{{item.otherDay}}天</span>
                        </p>
                        <p style="width:100%;display:flex;padding:5px 10px;">
                            <span style="display: inline-block;margin:0 10px;text-align: left;color:#36C635;">投资进度</span>
                            <el-progress :text-inside="true" :stroke-width="24" :percentage="item.cumulativeComplete" status="success" style="flex:1;"></el-progress>
                            <span style="position: absolute;bottom: -1.3vh;font-size: 12px;left: 100px;">累计工程完成量{{item.cumulativeComplete}}%</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="grid-content" style="height:38%;overflow: auto;">
                <div class="grid-tab bg-color1">
                    <div class="grid-tab-head" style="height:40px;">
                        <div>
                            <span class="title color3">关键岗位达标率</span>
                            <span class="box-green"></span>
                        </div>
                    </div>
                    <div class="hr"></div>
                    <div class="tab-item" style="font-size:16px;display: flex;color:#4D7BF4;height: 40px;margin:10px 0;">
                        <span class="" style="text-align: left;flex:1;">XXXXXX项目..</span>
                        <span class="" style="width:120px;text-align: center;">xxx项目经理</span>
                        <span class="" style="width:80px;text-align: center;">33%</span>
                        <span class="" style="width:100px;text-align: center;color:#FFBC01;">未达标</span>
                    </div>
                    <div class="tab-item" style="font-size:16px;display: flex;color:#4D7BF4;height: 40px;margin:10px 0;">
                        <span class="" style="text-align: left;flex:1;">XXXXXX项目..</span>
                        <span class="" style="width:120px;text-align: center;">xxx项目经理</span>
                        <span class="" style="width:80px;text-align: center;">33%</span>
                        <span class="" style="width:100px;text-align: center;color:#FFBC01;">未达标</span>
                    </div>
                </div>
            </div>
        </el-col>
        <el-col :span="10" class="box-h">
            <div class="box-content">
                <el-row style="height:100%;">
                    <el-col :span="6" class="item">
                        <div class="item-div">
                            <p>项目总数</p><p>{{num.all}}</p>
                        </div>
                        <img src="../../assets/image/box-l.png" class="img-l" />
                        <img src="../../assets/image/box-r.png" class="img-r" />
                    </el-col>
                    <el-col :span="6" class="item">
                        <div class="item-div">
                            <p>在建项目</p><p>{{num.zj}}</p>
                        </div>
                        <img src="../../assets/image/box-l.png" class="img-l" />
                        <img src="../../assets/image/box-r.png" class="img-r" />
                    </el-col>
                    <el-col :span="6" class="item">
                        <div class="item-div">
                            <p>竣工项目</p><p>{{num.jg}}</p>
                        </div>
                        <img src="../../assets/image/box-l.png" class="img-l" />
                        <img src="../../assets/image/box-r.png" class="img-r" />
                    </el-col>
                    <el-col :span="6" class="item">
                        <div class="item-div">
                            <p>停工项目</p><p>{{num.tg}}</p>
                        </div>
                        <img src="../../assets/image/box-l.png" class="img-l" />
                        <img src="../../assets/image/box-r.png" class="img-r" />
                    </el-col>
                </el-row>
            </div>
            <div class="grid-box bg-color1">
                <div class="grid-tab-head">
                    <div>
                        <span class="title color3">劳务实名制出勤统计</span>
                        <span class="box-green"></span>
                    </div>
                    <!-- <router-link to="/laborStat" class="more">更多...</router-link> -->
                </div>
                <div class="hr"></div>
                <div style="width:100%;height:calc( 100% - 50px );display:flex;">
                    <div style="width:70%;height:100%;">
                        <div id="entChart3" style="width:100%; height:100%"></div> 
                    </div>
                    <div class="echart" style="width: 30%;display: flex;flex-wrap: wrap;height: 100%;position: relative;">
                        <div id="entChart4" style="width:100%; height:50%"></div>
                        <div id="entChart5" style="width:100%; height:50%"></div> 
                    </div>
                </div>
            </div>
            <div class="grid-box">
                <div class="grid-tab-head">
                    <div>
                        <span class="title color3">劳务工资申报统计</span>
                        <span class="box-green"></span>
                    </div>
                    <!-- <span class="more">更多...</span>supLab -->
                    <!-- <router-link to="/supLab" class="more">更多...</router-link> -->
                </div>
                <div class="hr"></div>
                <div class="grid-tab-head">
                    <el-select v-model="selYear" class="yearSelect" @change="yearSelectFun">
                        <el-option
                        v-for="item in years"
                        :key="item.name"
                        :label="item.name"
                        :value="item.name">
                        </el-option>
                    </el-select>
                </div>
                <div style="width:100%;height:calc( 100% - 100px )">
                    <div id="entChart6" style="width:100%; height:100%"></div> 
                </div>
            </div>
        </el-col>
        <el-col :span="7" class="box-h">
            <div class="grid-content" style="height:28%;">
                <div class="grid-tab" style="color:#001498;">
                    <div class="grid-tab-head">
                        <div>
                            <span class="title color3" style="font-weight: bold;">劳务预警系统</span>
                            <span class="box-green"></span>
                        </div>
                        <!-- <router-link to="/laborWarn" class="more">更多...</router-link> -->
                    </div>
                    <div class="hr"></div>
                    <div class="tab-item" style="height:height:38px;">
                        <span class="color1">2个月工资未申报项目</span>
                        <div>
                            <img src="../../assets/image/warn.png" style="width:30px;height:30px;" />
                            <span class="item-num">{{warn.gzwsbxm}}</span>
                        </div>
                    </div>
                    <div class="tab-item" style="height:height: 38px;">
                        <span class="color1">有考勤无工资</span>
                        <div>
                            <img src="../../assets/image/warn.png" style="width:30px;height:30px;" />
                            <span class="item-num">{{warn.ykqwgz}}</span>
                        </div>
                    </div>
                    <div class="tab-item" style="height:height: 38px;">
                        <span class="color1">有工资无考勤</span>
                        <div>
                            <img src="../../assets/image/warn.png" style="width:30px;height:30px;" />
                            <span class="item-num">{{warn.ygzwkq}}</span>
                        </div>
                    </div>
                    <div class="tab-item" style="height:height: 38px;">
                        <span class="color1">月工资超30000元</span>
                        <div>
                            <img src="../../assets/image/warn.png" style="width:30px;height:30px;" />
                            <span class="item-num">{{warn.ycsw}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-content" style="height:38%;overflow: auto;">
                <div class="grid-tab">
                    <div class="grid-tab-head" style="height:40px;">
                        <div>
                            <span class="title color3">质量安全红线管理</span>
                            <span class="box-green"></span>
                        </div>
                    </div>
                    <div class="hr"></div>
                    <div class="tab-item" style="font-size:16px;display: flex;color:#4D7BF4;height: 40px;margin:10px 0;">
                        <span class="" style="text-align: left;flex:1;">XXXXXX项目..</span>
                        <span class="" style="width:200px;text-align: left;">安全管理、危大工程</span>
                        <span class="" style="width:100px;text-align: center;color:#FFBC01;">组织整改</span>
                    </div>
                    <div class="tab-item" style="font-size:16px;display: flex;color:#4D7BF4;height: 40px;margin:10px 0;">
                        <span class="" style="text-align: left;flex:1;">XXXXXX项目..</span>
                        <span class="" style="width:200px;text-align: left;">安全管理、危大工程</span>
                        <span class="" style="width:100px;text-align: center;color:#FFBC01;">组织整改</span>
                    </div>
                </div>
            </div>
            <div class="grid-content" style="height:34%;">
                <div class="grid-tab bg-color1">
                    <div class="grid-tab-head">
                        <div>
                            <span class="title color3" style="font-weight: bold;">项目验收统计</span>
                            <span class="box-green"></span>
                        </div>
                    </div>
                    <div style="width:100%;height:calc( 100% - 50px );position: relative;overflow: hidden;">
                        <div style="width:40%;height:100%;display: flex;flex-wrap: wrap;align-content: end;">
                            <div class="tab-item" style="font-size:16px;justify-content: flex-start;padding:0 0 0 10px;">
                                <span style="width:25px;height:15px;background:#17B2FE;display: inline-block;margin-right:10px;"></span>
                                <span class="color2">分项验收：   达标率{{checkNum.jsdw}}%</span>
                            </div>
                            <div class="tab-item" style="font-size:16px;justify-content: flex-start;padding:0 0 0 10px;">
                                <span style="width:25px;height:15px;background:#4D7BF4;display: inline-block;margin-right:10px;"></span>
                                <span class="color2">分部验收：   达标率{{checkNum.jldw}}%</span>
                            </div>
                            <div class="tab-item" style="font-size:16px;justify-content: flex-start;padding:0 0 0 10px;">
                                <span style="width:25px;height:15px;background:#CEFF00;display: inline-block;margin-right:10px;"></span>
                                <span class="color2">整改未达标：  {{checkNum.sgdw}}次</span>
                            </div>
                        </div>
                        <div style="width:100%;height:100%;position: absolute;top: 0;left: 15%;">
                            <div id="entChart2" style="width:100%; height:100%"></div>
                        </div>
                    </div>
                </div>
            </div>
        </el-col>
    </el-row>
</template>
<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
export default {
    data(){
        return{
            groupId:'',
            warn:{
                ycsw: 0, //有工资超3万
                ykqwgz: 0, //有考勤无工资
                gzwsbxm: 0, // 工资未申报项目
                ygzwkq: 0 //有工资无考勤
            },
            areaId:'',
            num: {     //项目数量
                all: 0,
                zj: 0,
                tg: 0,
                jg: 0,
            },
            years:[],
            selYear:new Date().getFullYear(),
            checkNum:{jsdw:0,jldw:0,sgdw:0},
            showFiex:false,
            upNum:{
                allUploadProject:0,
                allTheContractors:0,
                allUploadPerson:0,
                allUploadShift:0,
            },
            progressList:[],//进度列表
        }
    },
    mounted(){
        this.groupId = this.$store.state.groupId
        if ('' == this.groupId) {
            this.$store.commit('setGroupId')
            this.groupId = this.$store.state.groupId
        }
        var year = new Date().getFullYear()
        for(var i=0;i<5;i++){
            var obj = {
                name:parseInt(year)-i
            }
            this.years.push(obj)
        }
        // if(this.$route.path=='/homeLop'){
        //     this.showFiex = true
        // }
        //this.getArea()
        //this.setData1()//上传出勤（月）统计
        this.getAllNum()//获取项目数
        this.getData()//获取进度列表
        this.setData2()//项目检查统计
        this.setData3()//劳务实名制出勤统计
        this.setData4()//总劳务出勤
        this.setData5()//总申报劳务工资
        this.setData6()//劳务工资申报统计
        this.getData1()//获取劳务实名制出勤统计
        //this.setData7()//PM10实时检测
        //this.setData8()//塔吊实时监测
        //this.setData9()//升降机实时监测
    },
    methods:{
        //获取区域id
        // getArea() {
        //     let that = this
        //     myHttp.getSuperviseById({ id: this.groupId }).then(
        //         function(resp) {
        //         if (resp.data.code == '200') {
        //             that.areaId = resp.data.data.supervise.areaId
        //             that.getData() //列表
        //             that.getAllNum()//获取项目数量
        //             that.getWagesData()//获取劳务工资
        //             that.getAttendFun()//获取劳务考勤人员统计
        //             that.getEnvNum()//获取PM10监测
        //             that.getCheckNum()//获取检查统计
        //             that.getAllNumWage()//获取总劳务工资
        //             that.getAttendNum()//获取总劳务出勤
        //             that.getUploadData()//获取上传数据
        //         }
        //         },
        //         function() {}
        //     )
        // },

        //获取数据
        getData(){
            var that = this
            var opt = {
                entId : this.groupId,
                pageNum:1,
                pageSize:10000,
                joinType:3,
            }
            myHttp.getProjectPageListByEntIdAndJoinType(opt).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.pageInfo.list || []
                    for(var i=0;i<list.length;i++){
                        //list[i].index = ((that.currentPage - 1) * that.pageSize)+(i+1);
                        if(list[i].allDay==0){
                            list[i].progress = 0
                        }else{
                            list[i].progress = ((parseInt(list[i].allDay)-parseInt(list[i].otherDay))/parseInt(list[i].allDay)*100).toFixed(0)
                        }
                        list[i].progress = parseFloat(list[i].progress)
                        list[i].cumulativeComplete = list[i].cumulativeComplete?parseFloat(list[i].cumulativeComplete):0
                    }
                    that.progressList = list
                }
            })

        },

        //获取检查统计
        getCheckNum(){
            var that = this
            myHttp.getStatistical({
                groupId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.entity
                    var obj = {
                        jsdw: data.jsdw[0].zongshu,
                        jldw: data.jldw[0].zongshu,
                        sgdw: data.sgdw[0].zongshu,
                        all: parseInt(data.jsdw[0].zongshu)+parseInt(data.jldw[0].zongshu)+parseInt(data.sgdw[0].zongshu)
                    }
                    that.checkNum = obj
                    that.setData2(data,obj.all)
                    // if(that.search.unit==1){
                    //     var obj = data.jsdw[0]
                    //     obj.buhege = parseInt(obj.zongshu) - parseInt(obj.hege)
                    //     that.num = obj
                    // }else if(that.search.unit==2){
                    //     var obj = data.sgdw[0]
                    //     obj.buhege = parseInt(obj.zongshu) - parseInt(obj.hege)
                    //     that.num = obj
                    // }else{
                    //     var obj = data.jldw[0]
                    //     obj.buhege = parseInt(obj.zongshu) - parseInt(obj.hege)
                    //     that.num = obj
                    // }
                }
            })
        },

        //获取区域上传数据
        getUploadData(){
            var that = this
            myHttp.secAllProjectAllPersonAttendAndSomething({
                areaId:this.areaId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    //console.log(resp)
                    var data = resp.data.data.project
                    that.upNum = data
                }
            })
        },

        //获取项目数量
        getAllNum() {
            var that = this
            myHttp.getListEnterpriseAndJoinType({
                entId:this.groupId,
                joinType:'3'
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var data = resp.data.data
                    that.num.all = data.all
                    that.num.zj = data.zj.zjxm
                    that.num.tg = data.tg.tgxm
                    that.num.jg = data.jg.jgxm
                }
            })
            // myHttp.getListSupervise({
            //     entId: this.groupId
            //     })
            //     .then(function(resp) {
            //         console.log(resp)
            //     if (resp.data.code == '200') {
            //         var data = resp.data.data
            //         that.num.all = data.all
            //         that.num.zj = data.zj.zjxm
            //         that.num.tg = data.tg.tgxm
            //         that.num.jg = data.jg.jgxm
            //     }
            // })
            // myHttp.getSuperviseNum({
            //     areaId: this.areaId,
            //     stu:0
            // }).then(function(resp) {
            //     if (resp.data.code == '200') {
            //         var data = resp.data.data
            //         that.num.all = data.all
            //         that.num.zj = data.zj.zjxm
            //         that.num.tg = data.tg.tgxm
            //         that.num.jg = data.jg.jgxm
            //     }
            // })
        },

        //监听年变化
        yearSelectFun(){
            this.getWagesData()
        },

        //获取劳务数量统计
        getData1() {
            var that = this
            myHttp.getLaborStatisByEntId({
                entId: this.groupId
            }).then(function(resp) {
                //console.log(resp)
                if (resp.data.code == '200') {
                resp.data.data.attendCount.ysm = resp.data.data.gatherCount.ysm
                var obj = {
                    zaiCe:resp.data.data.attendCount.zaiCe,
                    zaiZhiAll:resp.data.data.attendCount.zaiZhi,
                    zaiChangAll:resp.data.data.attendCount.zaiChang,
                    chuQinAll:resp.data.data.attendCount.chuQin,
                    weiShiMingAll:resp.data.data.gatherCount.ysm,
                }
                that.setData3(obj)

                var list = resp.data.data.classCount || []
                var manger = 0,
                    other = 0,
                    all = 0
                for (var i = 0; i < list.length; i++) {
                    if (list[i].teamsType == '1') {
                    other += parseInt(list[i].cq)
                    } else {
                    manger += parseInt(list[i].cq)
                    }
                }
                all = other + manger
                var manger = resp.data.data.allAttendCount.allManagers
                var other = resp.data.data.allAttendCount.allWorkers
                var all = resp.data.data.allAttendCount.allPersons
                var option = {
                    manger: manger,
                    other: other,
                    all: all
                }
                that.setData4(option)
                }
            },
            function() {}
        )},

        //获取劳务工资
        getWagesData(){
            let that = this
            myHttp.getAreaSalaryStatisByMonth({
                areaId:this.areaId,
                year:this.selYear
            }).then(function(resp){
                var data = resp.data.data.statistic||[]
                var list = []
                for(var i=0;i<data.length;i++){
                    list.push(data[i].applySalary||0)
                }
                that.setData6(list)
            })
        },

        //获取实名制人员统计(setData3)
        getAttendFun(){
            var that = this;
            myHttp.getLaborStatisInfoByAreaId({
                areaId:this.areaId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    // resp.data.data.attendCount.ysm = resp.data.data.gatherCount.ysm;
                    var attendNum = resp.data.data.renCount
                    // attendNum.wsm = resp.data.data.gatherCount.wsm||0
                    // attendNum.gj = resp.data.data.positionKey.positionKey||0
                    that.setData3(attendNum);
                    //  var manger = resp.data.data.allAttendCount.allManagers;
                    //  var other = resp.data.data.allAttendCount.allWorkers;
                    //  var all = resp.data.data.allAttendCount.allPersons;
                    // var option = {
                    //     manger:manger,
                    //     other:other,
                    //     all:all
                    // };
                    // that.setData4(option);
                }
            },function(){});
        },

        //获取人员总出勤统计
        getAttendNum(){
            var that = this;
            myHttp.getLaborAttendInfoByAreaId({
                areaId:this.areaId
            }).then(function(resp){
                if(resp.data.code=='200'){
                     var manger = resp.data.data.allManagers;
                     var other = resp.data.data.allWorkers;
                     var all = parseInt(resp.data.data.allManagers)+parseInt(resp.data.data.allWorkers);
                    var option = {
                        manger:manger,
                        other:other,
                        all:all
                    };
                    that.setData4(option);
                }
            },function(){});
        },

        //获取项目数量
        getAllNumWage(){
            var that = this
            myHttp.getSalaryStatisByArea({
                areaId:this.areaId,
                applyMonth:util.myTime.getCurMonth()
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.map
                    that.setData5(data)
                }
            })
        },

        //获取环境数量
        getEnvNum(){
            var that = this;
            myHttp.getRealTimePM10GroupByAreaId({
                areaId:this.areaId,
            }).then(function(resp){
                if(resp.data.code=="200"){
                    var list = resp.data.data.pm10Group||[];
                    var all = 0,normal = 0,other = 0;
                    for(var i=0;i<list.length;i++){
                        all++;
                        if(list[i].state=='3'){
                            other++;
                        }else{
                            normal++;
                        }
                    }
                    var data = {
                        all:all,
                        allProgress:parseFloat(all/100),
                        normal:normal,
                        norProgress:parseFloat(normal/100),
                        other:other,
                        otherProgress:parseFloat(other/100)
                    }
                    that.setData7(data);
                }
            },function(){});
        },

        //获取塔吊
        // getTowerNum(){
        //     var that = this;
        //     myHttp.getRealTimeTowerByAreaId({
        //         areaId:this.areaId
        //     }).then(function(resp){
        //         if(resp.data.code=="200"){
        //             var data = resp.data.data.tower;
        //             var all = data.zong||0;
        //             var normal = data.zhengChang||0;
        //             var other = data.yujing||0;
        //             var data = {
        //                 all:all,
        //                 allProgress:parseFloat(all/100),
        //                 normal:normal,
        //                 norProgress:parseFloat(normal/100),
        //                 other:other,
        //                 otherProgress:parseFloat(other/100)
        //             }
        //             that.setData8(data);
        //         }
        //     },function(){});
        // },
        
        //上传出勤（月）统计
        // setData1(data){
        //     var option={
        //         title : {
        //             text: '上传出勤（月）统计',
        //             x:'left',
        //             y:'top',
        //             textStyle:{
        //                 fontSize:'16',
        //                 fontWeight:'400',
        //                 color:'#ffffff'
        //             }
        //         },
        //         color: ['#3398DB'],
        //         tooltip : {
        //             trigger: 'axis',
        //             axisPointer : {            // 坐标轴指示器，坐标轴触发有效
        //                 type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
        //             }
        //         },
        //         grid: {
        //             left: '3%',
        //             right: '4%',
        //             bottom: '0%',
        //             top: '18%',
        //             containLabel: true
        //         },
        //         xAxis : [
        //             {
        //                 type : 'category',
        //                 data : ['1月', '2月', '3月', '4月'],
        //                 axisTick: {
        //                     show: false,
        //                     alignWithLabel: true,
        //                 },
        //                 axisLine:{ //y轴
        //                     show:false
        //                 },
        //                 axisLabel: {
        //                     show: true,
        //                     textStyle: {
        //                         color: '#1B3BF5',
        //                         fontWeight: 'Bold'
        //                     }
        //                 }
        
        //             }
        //         ],
        //         yAxis : [
        //             {
        //                 type : 'value',
        //                 min: 100,
        //                 max: 2000,
        //                 interval:  500,
        //                 splitArea: {
        //                     // show: true  灰白背景
        //                 },
        //                 axisTick:{ //y轴刻度线
        //                     show:false
        //                 },
        //                 axisLine:{ //y轴
        //                     show:false
        //                 },
        //                 axisLabel: {
        //                     show: true,
        //                     textStyle: {
        //                         color: '#ffffff'
        //                     }
        //                 }
        //             }
        //         ],
        //         series : [
        //             {
        //                 name:'上传出勤统计',
        //                 type:'bar',
        //                 barWidth: '20%',
        //                 itemStyle:{
        //                 normal:{
        //                     //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
        //                     color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{ 
        //                         offset: 0,
        //                         color: '#30B4EF'
        //                     }, {
        //                         offset: 1,
        //                         color: '#C8EBFB'
        //                     }])
        //                 }
        //                 },
        //                 data:[1800, 1650, 1680, 1200]
        //             }
        //         ]
        //     }
        //     var page = this.$echarts.init(document.getElementById('myChart1'));
        //     page.setOption(option);
        // },

        //项目检查统计
        setData2(data,all){
            if(!data){
                data = {
                    jsdw:[{zongshu:0,buhege:0,hege:0}],
                    jldw:[{zongshu:0,buhege:0,hege:0}],
                    sgdw:[{zongshu:0,buhege:0,hege:0}],
                }
            }
            all = all?all:0
            var option = {
                tooltip: {
                    show:false,
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                legend: {
                    orient: "vertical",
                    x: "left",
                    y:'center',
                    data: ["建设单位", "监理单位", "施工单位"],
                    show:false
                },
                // graphic: {
                //     type: "text", 
                //     left: "center",
                //     top: "middle",
                //     z: 2,
                //     style: {
                //         text: data.all+"个\n\n发起总数",
                //         textAlign: "center",
                //         fill: "#1B3BF5", //文字的颜色
                //         width: 30,
                //         height: 30,
                //         fontSize: 18
                //     },
                //     backgroundColor:'#ffffff',
                // },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        // selectedMode: 'single',
                        center: ['50%', '40%'],
                        radius: [0, '40%'],
                        label: {
                            position: 'inner',
                            color:'#1B3BF5',
                            verticalAlign:'top',
                            padding:[-30,0,25,0],
                            fontSize:'14',
                            fontWeight:600,
                        },
                        itemStyle:{
                            color:'#ffffff'
                        },
                        labelLine: {
                            show: false
                        },
                        hoverAnimation: false,
                        data: [
                            {value: 0, name: all+"项\n\n总验收"},
                        ]
                    },
                    {
                        name: "检查统计",
                        type: "pie",
                        center: ['50%', '40%'],
                        radius: ["40%", "65%"],
                        // hoverAnimation: false,
                        itemStyle: {
                            normal: {
                                color: function(params) {
                                    var colorList = ["#17B2FE","#4D7BF4", "#CEFF00", "#FF8001"];
                                    return colorList[params.dataIndex];
                                }
                            }
                        },
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: false,
                            },
                            emphasis: {
                                show: true,
                                formatter:function(a,i){
                                    var pargress = a.data.value==0?0:(parseInt(a.data.hege)/parseInt(a.data.value)*100).toFixed(2)
                                    return a.data.name+'检查：'+a.data.value+'\n符合要求：'+a.data.hege+'次\n不符合要求：'+a.data.buhege+'次\n符合率：'+pargress+'%'
                                },
                                backgroundColor: '#1259E6',
                                borderColor: '#1259E6',
                                borderWidth: 1,
                                borderRadius: 4,
                                color:'#ffffff',
                                fontSize: 12,
                                padding: [5, 5],
                            },
                        },
                        labelLine: {
                            normal: {
                                show: false
                            },
                            emphasis: {
                                show: true,

                            }
                        },
                        data: [
                            {value:data.jsdw[0].zongshu, name:"建设单位",hege:data.jsdw[0].hege,buhege:data.jsdw[0].buhege},
                            { value: data.jldw[0].zongshu, name: "监理单位",hege:data.jldw[0].hege,buhege:data.jldw[0].buhege },
                            { value: data.sgdw[0].zongshu, name: "施工单位",hege:data.sgdw[0].hege,buhege:data.sgdw[0].buhege },
                        ]
                    }
                ]
            }
            var page = this.$echarts.init(document.getElementById('entChart2'));
            page.setOption(option);
        },

        //劳务实名制出勤统计
        setData3(data){
            if(!data){
                data = {
                    zaiCe:0,
                    zaiZhiAll:0,
                    zaiChangAll:0,
                    chuQinAll:0,
                    weiShiMingAll:0,
                }
            }
            var jindu = '98'
            var option = {
                tooltip : {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)",
                    show:false,
                },
                legend: {
                    top:'30',
                    x : 'left',
                    y : 'top',
                    orient:'vertical',
                    align:'right',
                    zlevel:-1,
                    data:['在册人数','在职人数','出勤人数','在场人数','未实名核验'],
                    textStyle:{
                        color:'#ffffff',
                        fontSize:'16'
                    }
                },
                calculable : true,
                series : [
                    {
                        name: '',
                        type: 'pie',
                        // selectedMode: 'single',
                        radius: [0, '20%'],
                        center : ['50%', '50%'],
                        // label: {
                        //     position: 'inner',
                        //     color:'#1B3BF5',
                        //     verticalAlign:'top',
                        //     padding:[-10,0,30,0],
                        //     fontSize:'12',
                        // },
                        itemStyle:{
                            color:'#CEFF00'
                        },
                        labelLine: {
                            show: false
                        },
                        hoverAnimation: false,
                        data: [
                            {value: 0, name: ""},
                        ]
                    },
                    {
                        name:'实名制劳务统计',
                        type:'pie',
                        radius : [50, 100],
                        center : ['50%', '50%'],
                        roseType : 'radius',
                        itemStyle: {
                            normal: {
                                color: function(params) {
                                    var colorList = ["#4D7BF4", "#688CE9", "#8CA9F6","#B3BFDC","#FFBC01","#FFBC01"];
                                    return colorList[params.dataIndex];
                                }
                            }
                        },
                        label: {
                            normal: {
                                show: false,
                            },
                            emphasis: {
                                show: true,
                                //formatter: '{b}：{c}人 \n\n  在岗率：{@jindu}% ',
                                formatter:function(a,i){
                                    return a.data.name+'：'+a.data.value +'\n\n占比：'+a.data.jindu+'%'
                                },
                                backgroundColor: '#1259E6',
                                borderColor: '#1259E6',
                                borderWidth: 1,
                                borderRadius: 4,
                                color:'#ffffff',
                                fontSize: 14,
                                padding: [10, 10],
                            },
                            
                        },
                        lableLine: {
                            normal: {
                                show: false
                            },
                            emphasis: {
                                show: true
                            }
                        },
                        data:[
                            {value:data.zaiCe, name:'在册人数',jindu:'100'},
                            {value:data.zaiZhiAll, name:'在职人数',jindu:((data.zaiZhiAll/data.zaiCe)*100).toFixed(2)},
                            {value:data.chuQinAll, name:'出勤人数',jindu:((data.chuQinAll/data.zaiCe)*100).toFixed(2)},
                            {value:data.zaiChangAll, name:'在场人数',jindu:((data.zaiChangAll/data.zaiCe)*100).toFixed(2)},
                            {value:data.weiShiMingAll, name:'未实名核验',jindu:((data.weiShiMingAll/data.zaiCe)*100).toFixed(2)},
                        ]
                    }
                ]
            }
            var page = this.$echarts.init(document.getElementById('entChart3'));
            page.setOption(option);
        },

        //总劳务出勤
        setData4(data){
            if(!data){
                data = {
                    manger:0,
                    other:0,
                    all:0
                }
            }
            var option = {
                title : {
                    text: '总劳务出勤',
                    x:'center',
                    y:'bottom',
                    textStyle:{
                        fontSize:'16',
                        color:'#ffffff'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/> {b} : {c} ({d}%)"
                },
                // graphic: {
                //     type: "text", 
                //     left: "center",
                //     top: "42%",
                //     z: 2,
                //     style: {
                //         text: data.all+"天次",
                //         textVerticalAlign :'middle',
                //         fill: "#1B3BF5", //文字的颜色
                //         width: 30,
                //         height: 30,
                //         fontSize: 12,
                //     }
                // },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        // selectedMode: 'single',
                        radius: [0, '50%'],
                        center : ['50%', '45%'],
                        label: {
                            position: 'inner',
                            color:'#1B3BF5',
                            verticalAlign:'top',
                            padding:[-10,0,30,0],
                            fontSize:'12',
                        },
                        itemStyle:{
                            color:'#ffffff'
                        },
                        labelLine: {
                            show: false
                        },
                        tooltip:{
                            formatter:function(){
                                return ''
                            }
                        },
                        hoverAnimation: false,
                        data: [
                            {value: 0, name: data.all+"天次"},
                        ]
                    },
                    {
                        name:'劳务出勤',
                        type:'pie',
                        radius: ['45%', '65%'],
                        center : ['50%', '45%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            normal: {
                                color: function(params) {
                                    var colorList = ["#AAE3FB", "#4ECBFF"];
                                    return colorList[params.dataIndex];
                                }
                            }
                        },
                        label: {
                            normal: {
                                show: false,
                                position: 'center'
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data:[
                            {value:data.manger, name:'管理出勤'},
                            {value:data.other, name:'工人出勤'},
                        ]
                    }
                ]
            }
            var page = this.$echarts.init(document.getElementById('entChart4'));
            page.setOption(option);
        },

        //总申报劳务工资
        setData5(data){
            data = data?data:{allSalary:0}
            var val = data.allSalary?parseFloat(data.allSalary):0
            if(val>100000){
                val = (val/10000).toFixed(2)
                data.allSalary = val + '万'
            }else{
                data.allSalary = val
            }
            var option={
                title : {
                    text: '总申报劳务工资',
                    x:'center',
                    y:'bottom',
                    textStyle:{
                        fontSize:'16',
                        color:'#ffffff'
                    }
                    
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b}: {c}万元 ({d}%)"
                },
                graphic: {
                    type: "text", 
                    left: "center",
                    top: "42%",
                    z: 2,
                    style: {
                        text: data.allSalary+"元",
                        textAlign: "center",
                        fill: "#1B3BF5", //文字的颜色
                        width: 30,
                        height: 30,
                        fontSize: 12,
                    }
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        // selectedMode: 'single',
                        radius: [0, '50%'],
                        center : ['50%', '45%'],
                        label: {
                            position: 'inner',
                            color:'#1B3BF5',
                            verticalAlign:'top',
                            padding:[-10,0,30,0],
                            fontSize:'12',
                        },
                        itemStyle:{
                            color:'#ffffff'
                        },
                        labelLine: {
                            show: false
                        },
                        tooltip:{
                            formatter:function(){
                                return ''
                            }
                        },
                        hoverAnimation: false,
                        data: [
                            {value: 0, name: data.allSalary+"元"},
                        ]
                    },
                    {
                        name:'劳务工资',
                        type:'pie',
                        radius: ['45%', '65%'],
                        center : ['50%', '45%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            normal: {
                                color: function(params) {
                                    var colorList = ["#4ECBFF","#AAE3FB"];
                                    return colorList[params.dataIndex];
                                }
                            }
                        },
                        label: {
                            normal: {
                                show: false,
                                position: 'center'
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data:[
                            {value:val, name:'总申报劳务工资'}
                        ]
                    }
                ]
            }
            var page = this.$echarts.init(document.getElementById('entChart5'));
            page.setOption(option);
        },

        //劳务工资申报统计
        setData6(data){
            data = data?data:[0,0,0,0,0,0,0,0,0,0,0,0]
            var option={
                color: ['#3115F3'],
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '0%',
                    top: '15%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月','8月','9月','10月','11月','12月',''],
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: '#ffffff',
                            fontWeight: 'Bold'
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: '#ffffff'
                        }
                    }
                },
                series: [{
                    // name:'本月申报',
                    label: {
                        normal: {
                            show: false,
                        },
                        emphasis: {
                            show: true,
                            formatter: '{b}\n 本月申报{c}元  ',
                            // formatter:function(a){
                            //     return ''
                            // },
                            backgroundColor: '#1259E6',
                            borderColor: '#1259E6',
                            borderWidth: 1,
                            borderRadius: 4,
                            color:'#ffffff',
                            fontSize: 14,
                            padding: [5, 5],
                            textAlign:'left',
                            // position: ['40%', '50%']
                        },
                        
                    },
                    data: data,
                    type: 'line',
                    areaStyle: {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: 'rgb(49, 21, 243)'
                        }, {
                            offset: 1,
                            color: 'rgba(228, 236, 234,0.4)'
                        }])
                    },
                }]
            }
            var page = this.$echarts.init(document.getElementById('entChart6'));
            page.setOption(option);
        },
        //PM10实时检测
        setData7(data){
            if(!data){
                data={
                    all:0,
                    allProgress:0,
                    normal:0,
                    norProgress:0,
                    other:0,
                    otherProgress:0,
                }
            }
            var option={
                tooltip : {
                    formatter: "{a} <br/>{c} 台"
                },
                grid: {
                    left: '0%',
                    right: '0%',
                    bottom: '0%',
                    top: '0%',
                },
                series : [
                    {
                        name: '监测台数',
                        type: 'gauge',
                        z: 3,
                        min: 0,
                        max: 100,
                        splitNumber: 10,
                        radius: '90%',
                        axisLine: {            // 坐标轴线
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: [[data.allProgress, '#10DD34'],[1, '#D0DE25']],
                                width: 3
                            }
                        },
                        axisTick: {            // 坐标轴小标记
                            length: 8,        // 属性length控制线长
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: 'auto'
                            }
                        },
                        splitLine: {           // 分隔线
                            length: 10,         // 属性length控制线长
                            lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                                color: 'auto'
                            }
                        },
                        axisLabel: {
                            show:false,
                        },
                        title : {
                            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                            // fontWeight: 'bolder',
                            fontSize: 18,
                            // fontStyle: 'italic'
                            offsetCenter:[0, '100%'],
                            color:'#ffffff'
                        },
                        detail : {
                            paddingTop:10,
                            // borderColor:'#14D442',
                            // borderWidth: 1,
                            fontSize:22,
                            offsetCenter:[0,'50%']
                        },
                        data:[{value: data.all, name: '监测台数'}]
                    },
                    {
                        name: '正常指标',
                        type: 'gauge',
                        center: ['20%', '55%'],    // 默认全局居中
                        radius: '80%',
                        min:0,
                        max:100,
                        endAngle:45,
                        splitNumber:10,
                        axisLine: {            // 坐标轴线
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: [[data.norProgress, '#10DD34'],[1, '#D0DE25']],
                                width: 2
                            }
                        },
                        axisTick: {            // 坐标轴小标记
                            length:5,        // 属性length控制线长
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: 'auto'
                            }
                        },
                        splitLine: {           // 分隔线
                            length:8,         // 属性length控制线长
                            lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                                color: 'auto'
                            }
                        },
                        axisLabel:{
                            show:false
                        },
                        pointer: {
                            width:5
                        },
                        title: {
                            offsetCenter: [0, '80%'],       // x, y，单位px
                            color:'#ffffff'
                        },
                        detail: {
                            offsetCenter:['10%','50%'],
                            color:'#17B2FE',
                            fontSize:22
                        },
                        data:[{value: data.normal, name: '正常指标'}]
                    },
                    {
                        name: '超标预警',
                        type: 'gauge',
                        center: ['77%', '50%'],    // 默认全局居中
                        radius: '80%',
                        min:0,
                        max:100,
                        startAngle:130,
                        // endAngle: 0,
                        splitNumber:10,
                        axisLine: {            // 坐标轴线
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: [[data.otherProgress, '#10DD34'],[1, '#D0DE25']],
                                width: 2
                            }
                        },
                        axisTick: {            // 坐标轴小标记
                            length:5,        // 属性length控制线长
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: 'auto'
                            }
                        },
                        splitLine: {           // 分隔线
                            length:8,         // 属性length控制线长
                            lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                                color: 'auto'
                            }
                        },
                        axisLabel:{
                            show:false
                        },
                        pointer: {
                            width:5
                        },
                        title: {
                            offsetCenter: [0, '80%'],       // x, y，单位px
                            color:'#ffffff'
                        },
                        detail: {
                            offsetCenter:['-10%','50%'],
                            color:'#17B2FE',
                            fontSize:22
                        },
                        data:[{value:data.other, name: '超标预警'}]
                    }
                ]
            }
            var page = this.$echarts.init(document.getElementById('myChart7'));
            page.setOption(option);
        },

        //塔吊实时监测
        setData8(data){
            if(!data){
                data={
                    all:0,
                    allProgress:0,
                    normal:0,
                    norProgress:0,
                    other:0,
                    otherProgress:0,
                }
            }
            var option={
                tooltip : {
                    formatter: "{a} <br/>{c} 台"
                },
                series : [
                    {
                        name: '监测台数',
                        type: 'gauge',
                        z: 3,
                        min: 0,
                        max: 100,
                        splitNumber: 10,
                        radius: '90%',
                        axisLine: {            // 坐标轴线
                            lineStyle: {       // 属性lineStyle控制线条样式
                                width: 10
                            }
                        },
                        axisTick: {            // 坐标轴小标记
                            length: 15,        // 属性length控制线长
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: 'auto'
                            }
                        },
                        splitLine: {           // 分隔线
                            length: 20,         // 属性length控制线长
                            lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                                color: 'auto'
                            }
                        },
                        axisLabel: {
                            backgroundColor: 'auto',
                            borderRadius: 2,
                            color: '#eee',
                            padding: 3,
                            textShadowBlur: 2,
                            textShadowOffsetX: 1,
                            textShadowOffsetY: 1,
                            textShadowColor: '#222'
                        },
                        title : {
                            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                            fontWeight: 'bolder',
                            fontSize: 18,
                            fontStyle: 'italic',
                            offsetCenter:[0, '90%'],
                            color:'#ffffff'
                        },
                        detail : {
                            paddingTop:10,
                            // borderColor:'#14D442',
                            // borderWidth: 1,
                            fontSize:22,
                            offsetCenter:[0,'50%'],
                            color:'#17B2FE',
                            fontWeight:'bolder'
                        },
                        data:[{value: data.all, name: '监测台数'}]
                    },
                    {
                        name: '正常指标',
                        type: 'gauge',
                        center: ['20%', '55%'],    // 默认全局居中
                        radius: '80%',
                        min:0,
                        max:100,
                        endAngle:60,
                        splitNumber:10,
                        axisLine: {            // 坐标轴线
                            lineStyle: {       // 属性lineStyle控制线条样式
                                width: 8
                            }
                        },
                        axisTick: {            // 坐标轴小标记
                            length:12,        // 属性length控制线长
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: 'auto'
                            }
                        },
                        axisLabel:{
                            show:false
                        },
                        splitLine: {           // 分隔线
                            length:20,         // 属性length控制线长
                            lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                                color: 'auto'
                            }
                        },
                        pointer: {
                            width:5
                        },
                        title: {
                            offsetCenter: [0, '80%'],       // x, y，单位px
                            color:'#ffffff'
                        },
                        detail: {
                            offsetCenter:[0,'50%'],
                            color:'#17B2FE',
                            fontSize:22,
                            fontWeight:'bolder'
                        },
                        data:[{value: data.normal, name: '正常指标'}]
                    },
                    {
                        name: '超标预警',
                        type: 'gauge',
                        center: ['77%', '50%'],    // 默认全局居中
                        radius: '80%',
                        min: 0,
                        max: 100,
                        startAngle: 120,
                        splitNumber: 10,
                        axisLine: {            // 坐标轴线
                            lineStyle: {       // 属性lineStyle控制线条样式
                                width: 8
                            }
                        },
                        axisTick: {            // 坐标轴小标记
                            splitNumber: 5,
                            length: 10,        // 属性length控制线长
                            lineStyle: {        // 属性lineStyle控制线条样式
                                color: 'auto'
                            }
                        },
                        axisLabel: {
                            show:false
                        },
                        splitLine: {           // 分隔线
                            length: 15,         // 属性length控制线长
                            lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                                color: 'auto'
                            }
                        },
                        pointer: {
                            width:2
                        },
                        title : {
                            offsetCenter: [0, '80%'],
                            color:'#ffffff'
                        },
                        detail : {
                            offsetCenter:[0,'50%'],
                            color:'#17B2FE',
                            fontSize:22,
                            fontWeight:'bolder'
                        },
                        data:[{value:data.other, name: '超标预警'}]
                    }
                ]
            }
            var page = this.$echarts.init(document.getElementById('myChart8'));
            page.setOption(option);
        },

        //升降机实时监测
        setData9(data){
            if(!data){
                data={
                    all:0,
                    allProgress:0,
                    normal:0,
                    norProgress:0,
                    other:0,
                    otherProgress:0,
                }
            }
            var option={
                tooltip : {
                    formatter: "{a} <br/>{c} 台"
                },
                series : [
                    {
                        name:'监测台数',
                        type:'gauge',
                        min:0,
                        max:100,
                        splitNumber:5,
                        radius: '90%',
                        axisLine: {            // 坐标轴线
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: [[data.allProgress, 'lime'],[1, '#1e90ff']],
                                width: 3,
                                shadowColor : '#fff', //默认透明
                                shadowBlur: 10
                            }
                        },
                        axisLabel: {            // 坐标轴小标记
                            textStyle: {       // 属性lineStyle控制线条样式
                                fontWeight: 'bolder',
                                // color: '#fff',
                                // shadowColor : '#fff', //默认透明
                                shadowBlur: 10
                            }
                        },
                        axisTick: {            // 坐标轴小标记
                            length :8,        // 属性length控制线长
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: 'auto',
                                shadowBlur: 10
                            }
                        },
                        splitLine: {           // 分隔线
                            length :10,         // 属性length控制线长
                            lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                                width:3,
                                // color: '#fff',
                                shadowColor : '#fff', //默认透明
                                // shadowBlur: 10
                            }
                        },
                        pointer: {           // 分隔线
                            // shadowColor : '#fff', //默认透明
                            shadowBlur: 5
                        },
                        title : {
                            textStyle: {       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                                fontWeight: 'bolder',
                                fontSize: 18,
                                fontStyle: 'italic',
                                color: '#17B2FE',
                                shadowBlur: 10
                            },
                            offsetCenter:[0,'95%'],
                        },
                        detail : {
                            offsetCenter:[0,'50%'],
                        },
                        data:[{value: data.all, name: '监测台数'}]
                    },
                    {
                        name:'正常指标',
                        type:'gauge',
                        center : ['25%', '55%'],    // 默认全局居中
                        radius : '80%',
                        min:0,
                        max:100,
                        endAngle:50,
                        splitNumber:5,
                        axisLine: {            // 坐标轴线
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: [[data.norProgress, 'lime'],[1, '#494c3b']],
                                width: 2,
                                // shadowColor : '#fff', //默认透明
                                // shadowBlur: 10
                            }
                        },
                        axisLabel: {            // 坐标轴小标记
                            show:false
                        },
                        axisTick: {            // 坐标轴小标记
                            length :10,        // 属性length控制线长
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: 'auto',
                                shadowBlur: 10
                            }
                        },
                        splitLine: {           // 分隔线
                            length :20,         // 属性length控制线长
                        },
                        pointer: {
                            width:5,
                            shadowColor : '#fff', //默认透明
                            shadowBlur: 5
                        },
                        title : {
                            offsetCenter: [0, '80%'],       // x, y，单位px
                            textStyle: {       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                                fontWeight: 'bolder',
                                fontStyle: 'italic',
                                color:'#ffffff',
                                shadowBlur: 10
                            }
                        },
                        detail : {
                            shadowBlur: 5,
                            width: 80,
                            height:30,
                            offsetCenter: [10, '50%'],       // x, y，单位px
                            
                        },
                        data:[{value: data.normal, name: '正常指标'}]
                    },
                    {
                        name:'超标预警',
                        type:'gauge',
                        center : ['75%', '50%'],    // 默认全局居中
                        radius : '80%',
                        min:0,
                        max:100,
                        startAngle:135,
                        // endAngle:45,
                        splitNumber:5,
                        axisLine: {            // 坐标轴线
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: [[data.otherProgress, '#ff4500'],[1, '#494c3b']],
                                width: 2,
                                shadowColor : '#fff', //默认透明
                                shadowBlur: 10
                            }
                        },
                        axisTick: {            // 坐标轴小标记
                            length :12,        // 属性length控制线长
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: 'auto',
                                shadowColor : '#fff', //默认透明
                                shadowBlur: 10
                            }
                        },
                        axisLabel: {
                            show:false
                        },
                        splitLine: {           // 分隔线
                            length :15,         // 属性length控制线长
                            
                        },
                        pointer: {
                            width:2,
                            shadowColor : '#fff', //默认透明
                            shadowBlur: 5
                        },
                        title : {
                            offsetCenter: [0, '80%'],       // x, y，单位px
                            textStyle: {       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                                fontWeight: 'bolder',
                                fontStyle: 'italic',
                                color:'#ffffff',
                                shadowBlur: 10
                            }
                        },
                        detail : {
                            shadowBlur: 5,
                            width: 80,
                            height:30,
                            offsetCenter: [0, '50%'], 
                        },
                        data:[{value: data.other, name: '超标预警'}]
                    }
                ]
            }
            var page = this.$echarts.init(document.getElementById('myChart9'));
            page.setOption(option);
        },

        //跳转
        toShowPop(){
            let routeUrl = this.$router.resolve({
                name: "statEnt",
            });
            window.open(routeUrl .href, '_blank');
        },
        //跳转地图
        toMap(){
            let routeUrl = this.$router.resolve({
                name: "mapDataEnt",
            });
            console.log(routeUrl)
            window.open(routeUrl .href, '_blank');
        },
        //跳转监控
        toMonitor(){
            let routeUrl = this.$router.resolve({
                name: "monitorEntHome",
            });
            console.log(routeUrl)
            window.open(routeUrl .href, '_blank');
        },
    }
}
</script>
<style scoped>
    *{
        box-sizing: border-box;
    }
    .nowrap {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .real-box{
        width: 100%;
        height: 100%;
    }
    .box-h{
        height: 100%;
    }
    .grid-content{
        width: 100%;
        height: 33.3333%;
        padding: 10px;
        box-sizing: border-box;
        position: relative;
    }
    .grid-tab{
        width: 100%;
        height: 100%;
        position: relative;
        box-sizing: border-box;
    }
    .bg-color1{
        background: rgba(255,255,255,.04);
    }
    .bg-color2{
        background: rgba(255,255,255,.27);
    }
    .grid-tab-head{
        width:100%;
        height:50px;
        display:flex;
        justify-content:space-between;
        align-items: center;
        padding-right: 10px;
    }
    .grid-tab-head .title{
        font-size:18px;
        /* font-weight: bold; */
    }
    .grid-tab-head .more{
        color:#4ECBFF;
        cursor: pointer;
    }
    .grid-tab .hr,.grid-box .hr{
        width:100%;
        height:2px;
        position: relative;
        background: linear-gradient(to right, #2E08F2, #080019);
    }
    .tab-item{
        width:100%;
        height:40px;
        display:flex;
        justify-content:space-between;
        align-items: center;
        font-size:20px;
        padding:0 20px;
    }
    .item-num{
        color:#8BADFC;
        margin-left:10px;
        position: relative;
        top: 4px;
        display: inline-block;
        min-width: 50px;
        text-align: right;
    }
    .box-green{
        width:20px;
        height:20px;
        background:#36C635;
        display: inline-block;
        position: relative;
        top: 4px;
        left: 20px;
        border-radius: 2px;
        animation: border_shrink 1s ease-out infinite;
    }
    @keyframes border_shrink {
        0% {
            box-shadow: 0 0px 0px 0px rgba(54, 198, 53, 0.14), 0 0px 0px 1px rgb(54, 198, 53,0.5);
        }
        100% {
            box-shadow: 0 0px 0px 3px rgba(54, 198, 53, 0.14), 0 0px 0px 4px rgba(54, 198, 53,0.5);
        }
    }
    .box-content{
        width:100%;
        height: 100px;
    }
    .box-content .item{
        position: relative;
        padding:20px;
        height:100%;
    }
    .box-content .item-div{
        width:100%;
        height:100%;
        background:#2058D9;
        display:flex;
        align-content: center;
        align-items: center;
        flex-wrap: wrap;
    }
    .box-content .item-div p{
        width:100%;
        color: #fff;
        font-size: 18px;
        margin: 0;
    }
    .box-content .img-l{
        width:84px;
        height:61px;
        position: absolute;
        top: 5px;
        left: 5px;
    }
    .box-content .img-r{
        width:84px;
        height:61px;
        position: absolute;
        bottom: 5px;
        right: 5px;
    }
    .grid-box{
        width: 100%;
        height: calc( 50% - 50px );
        position: relative;
        padding: 10px;
    }
    
    .color1{
        color:#8BADFC;
    }
    .color2{
        color: #fff;
    }
    .color3{
        color:#4D7BF4;
    }
    .color4{
        color:#2B95FF;
    }
    .color5{
        color:#CEFF00;
    }
    .floatBox{
        position:fixed;
        top:82px;
        right: 22px;
        width: 50px;
        height: 50px;
        cursor: pointer;
    }
    .float-button-Box{
        position:fixed;
        bottom:35px;
        left: 216px;
        /* width: 50px; */
        /* height: 50px; */
    }
    .nowrap {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    
    .progress-item{
        width: 100%;
        height: 90px;
        position: relative;
        font-size:16px;
        background:linear-gradient(92deg,rgba(2,25,149,1) 0%,rgba(0,3,84,1) 100%);
        color:#AECFDC;
        margin: 10px 0;
    } 
    .stateData::-webkit-scrollbar,.ent-menu::-webkit-scrollbar{
        /*滚动条整体样式*/
        width: 0px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 0px;
    }
    .stateData::-webkit-scrollbar-thumb,.ent-menu::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        background: #fff;
    }
    .stateData::-webkit-scrollbar-track,.ent-menu::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        background: #fff;
    }
</style>
<style>
    .yearSelect .el-input__inner{
        background: transparent;
        border: 0;
        color: #fff;
    }
    .real-box .el-button-group .el-button--primary:last-child{
        border-left-color: rgba(0, 0, 0, 1);
    }
    .stateData .el-progress-bar__outer{
        background: #4D7BF4;
    }
</style>